<div class="empty-page">
  <div class="empty-title">{{ title }}</div>
  <div class="empty-desc">空页面占位</div>
  <div class="empty-path">{{ routePath }}</div>
</div>
